import { connect } from 'react-redux';
import MenuMobileComponent from '../components/MenuMobileComponent';

const mapStateToProps = (state) => {
    const aovivoBar = state.aovivoBar;
    const music = aovivoBar.MediaPlayer.isLive
        ? aovivoBar.NowPlaying.musicLive
        : aovivoBar.NowPlaying.music;

    return {
        artist: music.artist,
        song: music.song,
        metaType: music.metaType,
        isMobile: state.clientInfo.isMobile,
    };
};

// passing an empty object for mapDispatchToProps to avoid dispatch being passed on and causing prop-types-exact to complain
export default connect(mapStateToProps, {})(MenuMobileComponent);
